import { render, staticRenderFns } from "./cmp-md-attr-value-viewer.vue?vue&type=template&id=8a9e12d4&scoped=true&"
import script from "./cmp-md-attr-value-viewer.vue?vue&type=script&lang=ts&"
export * from "./cmp-md-attr-value-viewer.vue?vue&type=script&lang=ts&"
import style0 from "./cmp-md-attr-value-viewer.vue?vue&type=style&index=0&id=8a9e12d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9e12d4",
  null
  
)

/* custom blocks */
import block0 from "./cmp-md-attr-value-viewer.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports